export default "__VITE_ASSET__Bg5pLfdF__"